import React from 'react';

const LoadingSpinner = ({ fullScreen = false }) => {
    const containerClass = fullScreen
        ? 'min-h-screen bg-gray-50 flex items-center justify-center'
        : 'flex items-center justify-center h-full py-12';

    return (
        <div className={containerClass}>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
    );
};

export default LoadingSpinner;